//#region : Imports

import { Component, OnInit, SecurityContext } from "@angular/core";

import { GlobalsService } from "../../globals.service";

import { Router } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { AsideComponent } from "src/app/aside/aside.component";
import { MainComponent } from "src/app/main/main.component";
//#endregion

declare var google: any;
declare var $: any;

@Component({
  selector: "app-analytics",
  templateUrl: "./analytics.component.html",
  styleUrls: ["./analytics.component.css"],
})
export class AnalyticsComponent implements OnInit {
  private myurl;
  private readonly textSize: number = 12;
  private readonly fontName: string = "";
  private static instance = null;
  private activeDeviceSnr: string = undefined;
  private activeDeviceName: string = undefined;

  constructor(
    private globals: GlobalsService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
    AnalyticsComponent.instance = this;
    this.globals.currentPage = "analytics";

    //Build url
    this.fontName = this.globals.buildSettings.fontFamily;
    this.myurl = this.getUrl(this.globals.buildSettings.iframeLinks[0]);

    // this.myurl = this.sanitizer.sanitize(SecurityContext.URL, this.sanitizer.bypassSecurityTrustResourceUrl("https://www.in-4mer.com/3rdparty/webviews/utilities/?itoken=" + this.globals.iotToken));
  }

  getUrl(url) {
    url = url.replace(/\$ctoken/g, `ctoken=${this.globals.token}`);
    url = url.replace(/\$itoken/g, `itoken=${this.globals.iotToken}`);
    url = url.replace(/\$personid/g, `personid=${this.globals.personid}`);
    url = url.replace(/\$accid/g, `accid=${this.globals.entityAccid}`);
    url = url.replace(/\$username/g, `username=${this.globals.username}`);
    url = url.replace(/\$nickname/g, `nickname=${this.globals.nickname}`);
    url = url.replace(/\$email/g, `email=${this.globals.email}`);
    url = url.replace(
      /\$flavour/g,
      `flavour=${this.globals.buildSettings.appFlavour}`
    );
    url = url.replace(/\$role/g, `role=${this.globals.userAccess.role}`);
    url = url.replace(
      /\$ftp/g,
      `flavourtype=${this.globals.buildSettings.flavourType}`
    );
    url = url.replace(/\$entity/g, `entity=${this.globals.entityName}`);

    url = this.sanitizer.sanitize(
      SecurityContext.URL,
      this.sanitizer.bypassSecurityTrustResourceUrl(url)
    );

    return url;
  }

  ngOnDestroy() {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    //Catch all clicks inside iframe and reset session
    let me = this;
    window.addEventListener("blur", function () {
      if (document.activeElement.id == "centerIframe") {
        me.globals.resetSession();
        setTimeout(function () {
          window.focus();
        }, 10000);
      }
    });
  }

  public static redraw(snr?: string, name?: string) {
    let me: AnalyticsComponent = AnalyticsComponent.instance;

    if (me) {
      me.activeDeviceSnr = snr;
      me.activeDeviceName = name;
    }
  }

  routeToMap() {
    this.router.navigate(["map"]);
  }

  // toggle drawer
  toggleAside() {
    let aside = AsideComponent.instance;
    aside.mapDrawerIsClosed = !aside.mapDrawerIsClosed;
  }
}
